export const isGenerateLinkOpen = (open) =>
  Boolean(open?.projectId && open?.subscriptionId);

export const getGenerateLinkFlowKey = (open, tracerId) => {
  if (!isGenerateLinkOpen(open)) {
    return "";
  }
  return [
    open.projectId,
    open.subscriptionId,
    tracerId || "",
    open.baseUrl || "",
    open.combinationId || "",
    open.complementaryInsurancePlanId || "",
    open.isSigned ? "1" : "0",
    open.isInfoCompleted ? "1" : "0",
  ].join("|");
};
